import LanguagesService from 'api/languages/languagesService';

export default {
    namespaced: true,
    state() {
        return {
            languages: [],
        }
    },
    getters: {
        languages: state => state.languages,
    },
    mutations: {
        setLanguages(state, payload) {
            const defaultLanguage = {
                flag: 'fr',
                id: 0,
                lang: 'Par défault' //this.$l10n.__('Par défault') ne fonctionne pas ?
            }
            state.languages = [defaultLanguage,...payload];
        },
    },
    actions: {
        fetchLanguages({commit}) {
            return new Promise((resolve, reject) => {
                LanguagesService.getAllLanguages()
                .then((response) => {
                    commit('setLanguages', response);
                    resolve();
                })
                .catch((err) => {
                    reject(err);
                })
            })
        }
    }
}